export const cafeBazaarInitialState = {
  ratingFilter: {
    hasFilter: false,
    isOpen: false,
    selectedIds: [],
    platform: 'cafeBazaar',
    componentName: 'ratingFilter',
    translateKey: 'alarm:rating',
    isDisabled: true,
    hasActivateSwitch: true,
  },
};
